import React, { Suspense, useState,useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import '../src/assets/css/main.css';
import '../src/assets/css/style.css';
import GetCurrentLocation from "./compontants/location/getCurrentLocation"; // Import the location component
import Nav from './compontants/nav/nav'
import Sidemenu from './compontants/sidemenu/sidemenu';
import HomePage from './compontants/pages/home/home';
import Properties from './compontants/pages/property/properties';
import InnerProperty from './compontants/pages/property/innerProperty';
import Footer from './compontants/footer/footer';
import ScrollToTop from './compontants/scrollTop';
import Login from './compontants/login/login';
import SavedProperty from './compontants/pages/property/savedProperties';
import MyProfile from './compontants/pages/profile/myProfile';
import Builders from './compontants/pages/builder/builders';
import Agents from './compontants/pages/agent/agents';
import InnerBuilders from './compontants/pages/builder/innerBuilders';
import BuilderProject from './compontants/pages/builder/builderProject';
import BuilderProjectList from './compontants/pages/builder/builderProjectList';
import InnerAgents from './compontants/pages/agent/innerAgent';
import BuilderPropertyList from './compontants/pages/builder/builderPropertyList';
import { ToastContainer } from 'react-toastify';
import BuilderProjectPreview from './compontants/pages/builder/builderProjectPreview';
import { RoleProvider } from './compontants/pages/Userdatacontext/Datacontexts';
import { LoginPopupContext } from './compontants/loginpopup/LoginPopupContext';
import { SearchProvider } from './compontants/searchContext/SearchContext';
import { FilterProvider } from './compontants/filterContext/filterContext';
import AboutUs from './compontants/pages/about/aboutUs'

import { Provider } from "react-redux";
import store from "./compontants/store";
const path = "/keralaplots/";

function App() {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isSidemenuActive, setIsSidemenuActive] = useState(false);

  // Toggle Login Popup visibility
  const toggleLoginPopup = (state) => {
      setIsPopupVisible(state);
      setIsSidemenuActive(false);
  };

  const closeSidemenu = () => {
      setIsSidemenuActive(false);
  };

  const [BuilderCompanyName, setBuilderCompanyName] = useState();
  const [idavlget, setIdval] = useState();

// useEffect(() => {
//     const companyName = localStorage.getItem('companyName');
//     const formattedCompanyName = companyName ? companyName.replace(/ /g, '%20') : '';
//     setBuilderCompanyName(formattedCompanyName); 
    
//     const idavl = localStorage.getItem('idval');
//     setIdval(idavl);
// }, []); 

//   // Pages where Nav and Footer should not appear
//   const noNavFooterPages = [`${path}${BuilderCompanyName}`,`${path}${BuilderCompanyName}/builderProjectList`,`${path}${BuilderCompanyName}/builderProject/${idavlget}`,`${path}${BuilderCompanyName}/builderPropertyList`];

//   // Determine if current route is a "no-nav-footer" page
//   const isNoNavFooterPage = noNavFooterPages.includes(window.location.pathname);

useEffect(() => {
  const companyName = localStorage.getItem('companyName');
  const formattedCompanyName = companyName ? companyName.replace(/ /g, '%20') : null;
  setBuilderCompanyName(formattedCompanyName); 
  
  const idavl = localStorage.getItem('idval');
  setIdval(idavl);
}, []); 

const noNavFooterPages = BuilderCompanyName ? [
  `${path}${BuilderCompanyName}`,
  `${path}${BuilderCompanyName}/builderProjectList`,
  `${path}${BuilderCompanyName}/builderProject/${idavlget}`,
  `${path}${BuilderCompanyName}/builderPropertyList`
] : [];

const isNoNavFooterPage = noNavFooterPages.includes(window.location.pathname);


  return (
    <Provider store={store}>
    <RoleProvider>
    <LoginPopupContext.Provider value={[isPopupVisible, setIsPopupVisible]}>
  
    <SearchProvider> {/* Wrap with SearchProvider */}
      
      <FilterProvider>
   
    <Router>
      <Suspense>
        <div className="App">
            {/* <Nav onNavClick={() => setIsSidemenuActive(!isSidemenuActive)} />
            <Sidemenu onLoginClick={() => toggleLoginPopup(true)} onClose={closeSidemenu} isSidemenuActive={isSidemenuActive} /> */}
            {!isNoNavFooterPage && (
                <>
                <Nav onNavClick={() => setIsSidemenuActive(!isSidemenuActive)} />
                <Sidemenu
                  onLoginClick={() => toggleLoginPopup(true)}
                  onClose={closeSidemenu}
                  isSidemenuActive={isSidemenuActive}
                />
              </>
            )}
            <ScrollToTop />
            <Login isPopupVisible={isPopupVisible} onClose={() => toggleLoginPopup(false)} />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Routes>
              <Route path={`${path}`} element={<HomePage />} />
              <Route path={`${path}properties`} element={<Properties />} />
              <Route path={`${path}innerProperty/:id/:name`} element={<InnerProperty />} />
              <Route path={`${path}savedProperties`} element={<SavedProperty />} />
              <Route path={`${path}myProfile`} element={<MyProfile />} /> 
              <Route path={`${path}builders`} element={<Builders />} />
              <Route path={`${path}agents`} element={<Agents />} />
              {/* <Route path={`${path}innerBuilders/:id/:id`} element={<InnerBuilders />} /> */}
              <Route path={`${path}:companyName`} element={<InnerBuilders />} />
              <Route path={`${path}:companyName/builderProject/:id`} element={<BuilderProject />} />
              <Route path={`${path}:companyName/builderProjectList`} element={<BuilderProjectList />} />
              <Route path={`${path}innerAgent/:id`} element={<InnerAgents />} />
              <Route path={`${path}:companyName/builderPropertyList`} element={<BuilderPropertyList />} />
              <Route path={`${path}builderProjectPreview/:id`} element={<BuilderProjectPreview />} />
              <Route path={`${path}aboutUs`} element={<AboutUs />} />
            </Routes>
            {/* <Footer /> */}
            {!isNoNavFooterPage && <Footer />}
        </div>
      </Suspense>
    </Router>
    
    </FilterProvider>
    
    </SearchProvider>
    
    </LoginPopupContext.Provider>
    </RoleProvider>
    </Provider>
  );
}

export default App;
